import React, { useState } from "react";
import { FaPencilAlt, FaClipboardList, FaUserFriends } from "react-icons/fa";
import ModalEditarProspecto from "./ModalEditarProspecto";
import ModalVisitasProspecto from "./ModalVisitasProspecto";

const formatoFecha = (fecha) =>
  fecha
    ? new Date(fecha).toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" })
    : "—";

export default function ProspectosTable({ prospectos, cargarProspectos }) {
  const [prospectoEditar, setProspectoEditar] = useState(null);
  const [prospectoVisitas, setProspectoVisitas] = useState(null);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-3 text-left font-semibold">Nombre</th>
              <th className="px-4 py-3 text-left font-semibold">Teléfono</th>
              <th className="px-4 py-3 text-left font-semibold">Colonia</th>
              <th className="px-4 py-3 text-left font-semibold">Dirección</th>
              <th className="px-4 py-3 text-left font-semibold">Fecha de registro</th>
              <th className="px-4 py-3 text-right font-semibold">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {prospectos.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-10 text-slate-400">
                  Sin prospectos registrados
                </td>
              </tr>
            ) : (
              prospectos.map((p) => (
                <tr
                  key={p.id_prospecto}
                  className="border-t border-slate-100 hover:bg-slate-50 transition"
                >
                  <td className="px-4 py-3">
                    <span className="flex items-center gap-2 font-medium text-slate-800">
                      <span className="w-7 h-7 rounded-md bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                        <FaUserFriends className="text-xs" />
                      </span>
                      {p.nombre}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-slate-600">{p.telefono || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{p.colonia || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{p.direccion || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{formatoFecha(p.fecha_creacion)}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-end gap-2">
                      <button
                        onClick={() => setProspectoEditar(p)}
                        title="Editar"
                        className="w-8 h-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 hover:border-indigo-200 transition"
                      >
                        <FaPencilAlt className="text-xs" />
                      </button>
                      <button
                        onClick={() => setProspectoVisitas(p)}
                        title="Visitas"
                        className="w-8 h-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-500 hover:bg-emerald-50 hover:text-emerald-600 hover:border-emerald-200 transition"
                      >
                        <FaClipboardList className="text-xs" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Modal Editar */}
      {prospectoEditar && (
        <ModalEditarProspecto
          prospecto={prospectoEditar}
          cargarProspectos={cargarProspectos}
          cerrar={() => setProspectoEditar(null)}
        />
      )}

      {/* Modal Visitas */}
      {prospectoVisitas && (
        <ModalVisitasProspecto
          prospecto={prospectoVisitas}
          cerrar={() => setProspectoVisitas(null)}
        />
      )}
    </div>
  );
}
